import { STATUS_LABELS, STATUS_STYLES, STATUS_STYLES_DARK } from "../lib/constants";

export const StatusBadge = ({ status, dark = false, className = "" }) => {
  const styles = dark ? STATUS_STYLES_DARK : STATUS_STYLES;
  return (
    <span
      data-testid={`order-status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs uppercase tracking-wider ${styles[status]} ${className}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
};
